/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_PreviewingInputs */

const cs_templates_previewing = /** @type {(inputs: Templates_PreviewingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuji náhled…`)
};

const en_templates_previewing = /** @type {(inputs: Templates_PreviewingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering preview…`)
};

/**
* | output |
* | --- |
* | "Rendering preview…" |
*
* @param {Templates_PreviewingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_previewing = /** @type {((inputs?: Templates_PreviewingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_PreviewingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_previewing(inputs)
	return cs_templates_previewing(inputs)
});